import React from "react";
import { Info } from "lucide-react";

/**
 * Standard FCA-style illustrative-rate disclaimer used above any panel that
 * displays mortgage rates.
 */
export default function RateDisclaimer({ className = "" }) {
    return (
        <div
            data-testid="rate-disclaimer"
            className={`flex items-start gap-3 text-xs md:text-sm text-brand-muted bg-brand-bg border border-brand-border rounded-lg px-4 py-3 leading-relaxed ${className}`}
        >
            <Info size={16} className="text-brand-primary shrink-0 mt-0.5" />
            <p>
                <span className="font-bold text-brand-primary">
                    Important:
                </span>{" "}
                The rates shown are for illustrative purposes only and are
                subject to status, lender assessment, credit profile,
                affordability, and individual circumstances. The actual rate
                available may vary depending on personal and financial
                circumstances.
            </p>
        </div>
    );
}
